import { ImportKeyItem } from '../containers/projectWorkspace/slice/types';

/**
 * Flattens a translation key file into `{ key, sourceText }` entries.
 *
 * Supports both flat (`{ "home.title": "Welcome" }`) and nested
 * (`{ home: { title: "Welcome" } }`) JSON, expanding nested objects into
 * dot-notation keys. String, number, and boolean leaves are kept; arrays and
 * null are ignored. Keys are preserved exactly as written; only exact-duplicate
 * keys (which the import would otherwise reject) are de-duplicated, keeping the
 * first occurrence.
 */
export function flattenKeyFile(input: unknown): ImportKeyItem[] {
  const raw: ImportKeyItem[] = [];

  const walk = (value: unknown, prefix: string): void => {
    if (!value || typeof value !== 'object' || Array.isArray(value)) {
      return;
    }
    Object.entries(value as Record<string, unknown>).forEach(([k, v]) => {
      const key = prefix ? `${prefix}.${k}` : k;
      if (typeof v === 'string') {
        raw.push({ key, sourceText: v });
      } else if (typeof v === 'number' || typeof v === 'boolean') {
        raw.push({ key, sourceText: String(v) });
      } else if (v && typeof v === 'object' && !Array.isArray(v)) {
        walk(v, key);
      }
    });
  };

  walk(input, '');

  const seen = new Set<string>();
  return raw.filter((entry) => {
    if (seen.has(entry.key)) return false;
    seen.add(entry.key);
    return true;
  });
}
